import modals from '../modal'

export default (function() {
  'use strict';

  let teamData;
  let teamModal;
  let teamModalTriggers;
  const teamGrid = document.querySelector('.team-grid')

  function showTeamDetail(teamUri) {

    const teamMemberDetails = teamData[teamUri]
    const teamDetailsContainer = teamModal.element

    const positionTitleElem = teamDetailsContainer.querySelector('[data-team-detail-position-title]')
    const nameElem = teamDetailsContainer.querySelector('[data-team-detail-name]')
    const imageElem = teamDetailsContainer.querySelector('[data-team-detail-image]')
    const bioElem = teamDetailsContainer.querySelector('[data-team-detail-bio]')

    nameElem.innerHTML = teamMemberDetails.name
    positionTitleElem.innerHTML = teamMemberDetails.position_title

    imageElem.src = teamMemberDetails.image.sizes['custom-size']

    bioElem.innerHTML = teamMemberDetails.bio
  }

  function clearTeamDetail() {
    const teamDetailsContainer = teamModal.element

    const positionTitleElem = teamDetailsContainer.querySelector('[data-team-detail-position-title]')
    const nameElem = teamDetailsContainer.querySelector('[data-team-detail-name]')
    const imageElem = teamDetailsContainer.querySelector('[data-team-detail-image]')
    const bioElem = teamDetailsContainer.querySelector('[data-team-detail-bio]')

    positionTitleElem.innerHTML = ''
    nameElem.innerHTML = ''
    imageElem.innerHTML = ''
    bioElem.innerHTML = ''
    imageElem.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='

    bioElem.innerHTML = ''
  }

  function handleTeamTriggerClick(event) {
    event.preventDefault()
    showTeamDetail(event.target.dataset.teamUri)
    teamModal.open(event.target)
  }

  function setupTeamGrid() {
    teamData = JSON.parse(document.getElementById('TeamMemberData').textContent.trim())

    teamModalTriggers = [...teamGrid.querySelectorAll('.js-team-detail-trigger')]
    teamModal = modals.getById('modal-team-detail')

    teamModalTriggers.forEach((trigger) => {
      trigger.addEventListener('click', handleTeamTriggerClick)
    })

    teamModal.element.addEventListener('close', handleModalClose)
  }

  function handleModalClose() {
    clearTeamDetail()
  }

  function init() {
    if (!teamGrid) {
      return;
    }

    window.addEventListener('DOMContentLoaded', () => {
      setupTeamGrid()
    })
  }

  return {
    init,
  }

})();
